import { type FleetSafetyAggregatedBy, type FleetSafetyReportRequest, type FleetSafetyRequest, FleetSafetyRequester, type FleetSafetyResponse } from '@cobliteam/api-lib';
import { Environment } from '@cobliteam/react-environments';
import { useMutation, useQuery } from '@tanstack/react-query';

const env = Environment.getInstance().getEnvironment();
// Lazy instantiation to avoid circular dependency issues
const getFleetSafetyRequester = () => new FleetSafetyRequester({ host: env.apiHost });

const QUERY_KEY = 'FLEET_SAFETY';

const useGetSafetyRows = (request: FleetSafetyRequest, aggregatedBy: FleetSafetyAggregatedBy) =>
  useQuery<FleetSafetyResponse>({
    queryKey: [QUERY_KEY, 'ROWS', JSON.stringify(request), aggregatedBy],
    queryFn: () => getFleetSafetyRequester().getFleetSafety(request, aggregatedBy),
    staleTime: 300000,
  });

const useGetFleetHasCameraProEventsFlag = () =>
  useQuery<boolean>({
    queryKey: [QUERY_KEY, 'CAMERA_PRO_FLAG'],
    queryFn: () => getFleetSafetyRequester().getFleetHasCameraProEventsFlag(),
    staleTime: 300000,
  });

const useRequestSafetyReport = () =>
  useMutation<string, unknown, { request: FleetSafetyReportRequest }>({
    mutationFn: (variables) => getFleetSafetyRequester().requestFleetSafetyReport(variables.request),
  });

export default {
  useGetSafetyRows,
  useGetFleetHasCameraProEventsFlag,
  useRequestSafetyReport,
};
